/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { KickHandAndMachineBendFamilyInformationModule } from './kick-hand-and-machine-bend-family-information.module';
export { KickHandAndMachineBendFamilyInformation } from './kick-hand-and-machine-bend-family-information.component';